// Subscribe Popup on Front Page

const subscribePopup = function ($) {

	// open popup
	$("#collapsed-popup").click(function () {
		$("#collapsed-popup").hide();
		$("#open-popup").slideToggle();

		// prevents body from scrolling when modal is open
		$("html").css("overflow", "hidden");
	});

	// close popup
	$("#close-popup").click(function () {
		$("#open-popup").hide();
		$("#collapsed-popup").show();

		// allows html to return to regular scroll
		$("html").css({ "overflow-y": "scroll", "overflow-x": "hidden" });
	});
};

export default subscribePopup;
